/**
 * Fireworks Animation Service
 * Creates beautiful fireworks animations for the New Year theme
 */

// Create fireworks container
let fireworksContainer = null;
let fireworksInterval = null;

/**
 * Initialize fireworks container
 */
export function initFireworks() {
  // Remove existing container if any
  if (fireworksContainer) {
    document.body.removeChild(fireworksContainer);
  }
  
  // Create container for fireworks
  fireworksContainer = document.createElement('div');
  fireworksContainer.className = 'fireworks-container';
  fireworksContainer.style.position = 'fixed';
  fireworksContainer.style.top = '0';
  fireworksContainer.style.left = '0';
  fireworksContainer.style.width = '100%';
  fireworksContainer.style.height = '100%';
  fireworksContainer.style.pointerEvents = 'none';
  fireworksContainer.style.zIndex = '9999';
  fireworksContainer.style.overflow = 'hidden';
  document.body.appendChild(fireworksContainer);

  // Start fireworks animations
  startFireworks();
}

/**
 * Create a single firework explosion
 */
function createFirework(x, y, color) {
  const firework = document.createElement('div');
  firework.style.position = 'absolute';
  firework.style.left = `${x}px`;
  firework.style.top = `${y}px`;
  firework.style.width = '5px';
  firework.style.height = '5px';
  firework.style.backgroundColor = color;
  firework.style.borderRadius = '50%';
  firework.style.animation = 'explode 1.5s ease-out forwards';
  
  fireworksContainer.appendChild(firework);
  
  // Remove firework after animation completes
  setTimeout(() => {
    if (firework.parentNode) {
      firework.parentNode.removeChild(firework);
    }
  }, 1500);
  
  // Create particles for explosion effect
  createParticles(x, y, color);
}

/**
 * Create particles for explosion effect
 */
function createParticles(x, y, color) {
  const particleCount = Math.floor(Math.random() * 30) + 20;
  
  for (let i = 0; i < particleCount; i++) {
    const particle = document.createElement('div');
    particle.style.position = 'absolute';
    particle.style.left = `${x}px`;
    particle.style.top = `${y}px`;
    particle.style.width = '4px';
    particle.style.height = '4px';
    particle.style.backgroundColor = color;
    particle.style.borderRadius = '50%';
    
    // Random direction and distance
    const angle = Math.random() * Math.PI * 2;
    const distance = Math.random() * 100 + 50;
    const tx = Math.cos(angle) * distance;
    const ty = Math.sin(angle) * distance;
    
    // Set CSS variables for animation
    particle.style.setProperty('--tx', `${tx}px`);
    particle.style.setProperty('--ty', `${ty}px`);
    
    // Add animation
    particle.style.animation = 'spread 1s ease-out forwards';
    
    fireworksContainer.appendChild(particle);
    
    // Remove particle after animation completes
    setTimeout(() => {
      if (particle.parentNode) {
        particle.parentNode.removeChild(particle);
      }
    }, 1000);
  }
}

/**
 * Start continuous fireworks
 */
function startFireworks() {
  fireworksInterval = setInterval(() => {
    // Only create fireworks if we're on the new year theme
    const appElement = document.querySelector('.app.theme-newyear');
    if (appElement) {
      // Random position
      const x = Math.random() * window.innerWidth;
      const y = Math.random() * window.innerHeight / 2; // Top half of screen
      
      // Random color from theme
      const colors = [
        '#ffd700', // gold
        '#c0c0c0', // silver
        '#cd7f32', // bronze
        '#ff0000', // red
        '#0000ff', // blue
        '#00ff00', // green
        '#800080', // purple
        '#00ffff'  // cyan
      ];
      const randomColor = colors[Math.floor(Math.random() * colors.length)];
      
      createFirework(x, y, randomColor);
    }
  }, 800); // Create a firework every 800ms
}

/**
 * Stop all animations and clean up
 */
export function destroyFireworks() {
  if (fireworksInterval) {
    clearInterval(fireworksInterval);
    fireworksInterval = null;
  }

  // Remove container
  if (fireworksContainer && fireworksContainer.parentNode) {
    fireworksContainer.parentNode.removeChild(fireworksContainer);
    fireworksContainer = null;
  }
}
